module.exports = __webpack_public_path__ + "AdobeStock_285202108_monitor2_iconcolors3.svg?d5a2f1d45e41fd02f4bf249f29aa3c56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_monitor2_iconcolors3.svg
// module id = 328
// module chunks = 0